<template>
  <div class="d-flex flex-row justify-space-between ma-2">
    <div id="page-title">
      <h2>
        {{ title }}
        <v-btn :disabled="$cannot('VIEW_HELPS')" icon small color="blue" @click="openHelp" :loading="help.loading">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
		<!-- <v-btn v-if="!$isMobile() && $can('VIEW_TOURS')" id="start-tour-btn" icon small color="blue" @click="startTour($route.name)" :loading="help.loading">
          <v-icon>mdi-school</v-icon>
        </v-btn> -->
				<v-chip v-if="isDiscontinued" color="warning" small label :title="$lang('main.labels.discontinued_hint')"> 
					{{ $lang('main.labels.discontinued') }}
				</v-chip>
      </h2>
    </div>
    <div class="align-content-center" id="breakdcrumbs">
      <v-breadcrumbs :items="breadcrumbs" class="mb-0 pb-0">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :disabled="false"
            :to="{
              name: item.to,
              params: item.params ? $route.params : {},
            }"
            :exact="true"
          >{{ $lang(`main.${item.text}`) }}</v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <v-dialog v-model="isOpenHelp" transition="dialog-bottom-transition" scrollable width="60%">
      <v-card v-if="isOpenHelp">
        <v-card-text v-if="help.loading">
          <v-row>
            <v-col>
              <v-skeleton-loader class="mx-auto" type="paragraph"></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-card-text>
        <div v-if="!help.loading && !helpContent">
          <v-card-title>
            <v-btn icon @click="isOpenHelp = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span>
              {{ $lang('helps.no_content') }}
            </span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" md="8">
                <v-skeleton-loader class="mx-auto" type="article"></v-skeleton-loader>
              </v-col>
              <v-col align="center" cols="12" xs="12" md="4">
                <v-img src="/img/help.svg" width="300px"></v-img>
                <p>{{ $lang('helps.no_answer') }} <a href="mailto:support@ciaobooking.com">support@ciaobooking.com</a></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
		<v-card-title v-if="!help.loading && !!helpContent">
		<v-btn icon @click="isOpenHelp = false">
			<v-icon>mdi-close</v-icon>
		</v-btn>
		<span>
			{{ helpContent.title }}
		</span>
		</v-card-title>
		<v-card-text v-if="!help.loading && !!helpContent" style="height: 500px">
		<v-row>
			<v-col cols="12" xs="12" md="8">
			<span v-html="helpContent.body"></span>
			</v-col>
			<v-col align="center" cols="12" xs="12" md="4">
			<v-img src="/img/help.svg" width="300px"></v-img>
					<p>{{ $lang('helps.no_answer') }} <a href="mailto:support@ciaobooking.com">support@ciaobooking.com</a></p>
			</v-col>
		</v-row>
		</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeHelp()">{{ $lang('main.close') }}</v-btn>
          <v-btn color="primary" @click="closeHelp(true)">{{ $lang('main.do_not_show_again') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

import {
  GET_HELPS_COLLECTION
} from "@/store/helps/actions";

import {
  INACTIVATE_HELP
} from "@/store/settings/actions";

export default {
	name: "CTitle",
	props: {
		route: {
			type: Object,
			default: {}
		},
	},
	data() {
		return {
			isOpenHelp: false,
		};
	},
  beforeMount() {
	  //this.showHelp();
  },
	methods: {
		getHelp(module) {
			this.$store.dispatch(GET_HELPS_COLLECTION, {
				path: module,
				published: 1
			});
		},
		openHelp() {
			this.isOpenHelp = true;
			this.getHelp(this.$route.name);
		},
    closeHelp(force) {
      this.isOpenHelp = false;

      if (force) {
        this.$store.dispatch(INACTIVATE_HELP, this.$route.name);
      }
    },
    showHelp() {
      if (this.inactiveHelps.indexOf(this.$route.name) === -1) {
        this.openHelp();
      }
    }
	},
	computed: {
		...mapState({
			help: state => state.helps.getCollectionRequest,
			inactiveHelps: state => state.settings.inactiveHelps,
		}),
		breadcrumbs() {
			let breadcrumbs = [];
			let breadcrumb = {};
			if (!this.route.meta.breadcrumbs) {
				return [{
					text: this.route.meta.title ? this.route.meta.title : 'titles.here',
					disabled: true,
				}]
			}

			let data = this.route.meta.breadcrumbs;

			data.map((path, i) => {
				breadcrumb = {
					text: path.text,
					to: path.to,
					params: path.params ? path.params : {},
				};
				breadcrumbs.push(breadcrumb);
			});

			breadcrumbs.push({
				text: this.route.meta.title ? this.route.meta.title : 'titles.here',
				disabled: true,
			});

			return breadcrumbs;
		},
		title() {
			if (!this.route.meta.title) {
				return null;
			}

			return this.$lang(`main.${this.route.meta.title}`)
		},
		isDiscontinued() {
			return !!this.route.meta.discontinued;
		},
		helpContent() {
			if (!this.help.collection.length) {
				return null;
			}
			let locale = this.$locale();

			return {
				title: this.help.collection[0].title[locale],
				body: this.help.collection[0].body[locale],
			}
		},
	},
}
</script>
